export const GetCurrentUser = (api) => {
    return api.get("/api/v1/Account/User")
}

export const GetUserPassword = (api) => {
    return api.get("/api/v1/Account/getUserPassword")
}